import React, { useState, useEffect } from 'react';
import './PatientComfort.css';
import comfort from './Images/2024-09-24-11-31-37-155.jpg'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {  FaCoffee, FaChild, FaClock,  FaRegCheckCircle,FaTv,FaCalendarCheck,FaTag,FaCreditCard, FaMedkit,  } from 'react-icons/fa';
import dental1 from '../home/Images/v1.png';
import dental2 from '../home/Images/IMG20240913134831.jpg';
import dental3 from'../home/Images/IMG_20231201_174221.jpg';
import dental4 from '../home/Images/dental2.png'

function PatientComfort() {
  const [showMore, setShowMore] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Check the screen size on mount and whenever the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    // Initialize screen size state
    handleResize();

    // Event listener for resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleReadMoreClick = () => {
    setShowMore(!showMore);
  };
const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock  size={40} />, label: " Time Management  " },
  ];


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
<div className="patientcomfort">
    <div className="patientcomfort-sec1">
      {/* Section 1: Trusted Care */}
      <div className="content">
          <div className="text-section">
            {/* <h1 className="section-header">SECTION 1</h1> */}
            <p className="trusted-text"><mark className='domark'>BOMBAY DENTAL ANTI-ANXIETY DENTIST</mark></p>
            <h1 className="exceptional"><mark className='expmrk'>Humane care </mark></h1>
            <h1 className="exceptional"><mark className='expmrk'>when you need </mark></h1>
            <h1 className="exceptional"><mark className='expmrk'>it most</mark></h1>
            <a href="/booknow" ><button className="book-button">BOOK ONLINE</button></a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
            {/* <p className="call-text">9582474046</p> */}
          </div>
      </div>
      </div>

      {/* Section 2: Dental Anxiety */}
      <div className="anxiety-section">
        <div className="anxiety-content">
          <h1 className="anxiety-title">Why does going to the dentist give me anxiety?</h1>

          <div className="anxiety-paragraph-wrapper paragraph-1">
        <p className="anxiety-paragraph">
          When dental anxiety is present, the most common response is to simply not go to the dentist for months or even years. It’s a natural reaction to want to avoid these unpleasant feelings completely. Unfortunately, this can lead to poor oral care overall and even worse dental problems, including:
        </p>
        <ul className="commitment-list">
          <li>Plaque and tartar buildup</li>
          <li>Cavities</li>
          <li>Gum disease</li>
          <li>Tooth loss</li>
          <li>Increasing gaps and crowding between teeth</li>
        </ul>
      </div>

      <div className="anxiety-paragraph-wrapper paragraph-2">
        <p className="anxiety-paragraph">
    
          {isSmallScreen && showMore && (
            <span> {/* Initially show only part of the content for small screens */}
              <br />
              We want to help you be proactive in your care.    When you keep your routine check-ups and cleanings and address problems when they’re small, you’ll be faced with fewer procedures and fewer dental expenses down the road. Doesn’t that sound nice!   We encourage you to keep regular check-ups for optimal oral health and long-term benefits.
            </span>
          )}
          {/* Always show the full text for large screens */}
          {!isSmallScreen && (
            <>
             
             We want to help you be proactive in your care.    When you keep your routine check-ups and cleanings and address problems when they’re small, you’ll be faced with fewer procedures and fewer dental expenses down the road. Doesn’t that sound nice!   We encourage you to keep regular check-ups for optimal oral health and long-term benefits.
            </>
          )}
        </p>
      </div>

      {isSmallScreen && (
        <button className="read-more-btn" onClick={handleReadMoreClick}>
          {showMore ? 'Read Less' : 'Read More'}
        </button>
      )}
 
    
          </div>
      </div>
          <section className="help-section">
      <div className="help-container">
        {/* Left Section - Image and Testimonial */}
        <div className="help-left">
          <img
            src={comfort} // Replace with the actual image URL
            alt="Patient and dentist"
            className="help-image"
          />
        
        </div>

        {/* Right Section - Title and Features */}
        <div className="help-right">
          <h1 className="help-title">How we help reduce dental anxiety</h1>
          <div className="help-feature">
            <h2 className="feature-title">Modern dental technology</h2>
            <p className="feature-text">
            Our office at South Mumbai is equipped with state-of-the-art tech to provide minimally-invasive procedures and ensure you’re always receiving the highest-quality care.

            </p>
          </div>
          <div className="help-feature">
            <h2 className="feature-title">Relaxation amenities</h2>
            <p className="feature-text">
            We help patients feel at ease through our bright, calming office environment, essential oils, our various plants brightening the space, healthy snacks and beverages, and our friendly, experienced team.

            </p>
          </div>
          <div className="help-feature">
            <h2 className="feature-title">Transparent and attentive experience</h2>
            <p className="feature-text">
            We do our best to ensure you don’t have any surprises when it comes to what to expect, the cost of treatment, or outcomes. Our experienced team is trained very vigorously in providing you the best experience, without taking up time from the rest of your day.

            </p>
          </div>
          {/* <blockquote className="testimonial">
            “Whether I’m visiting for something as simple as a cleaning, or as
            complex as an implant, I am always treated with respect and kindness
            and the results are solid. If you have any fear of dental treatment,
            your mind will be changed after visiting Bombay Dental.”
            <footer className="testimonial-author">— Tushita Singh</footer>
          </blockquote> */}
        </div>
      </div>
    </section>
    <div className="anxiety-section">
        <div className="anxiety-content">
          <h1 className="anxiety-title">
What Can I Do On My Own To Lessen Dental Anxiety?</h1>

          <div className="anxiety-paragraph-wrapper paragraph-1">
            <p className="anxiety-paragraph">
            Here are a few techniques many patients have used to cope with being afraid of dentists:
</p>
            <ul className="commitment-list">
          <li>Talk to us openly about your dental anxiety.
</li>
          <li>Don’t be afraid to tell us when you need a break from the session.
</li>
          <li>Employ the use of mindful breathing exercises to help relax.
</li>
          <li>Bring a support person with you to your visit.
</li>
          <li>Use our relaxing facilities of headphones and TV to listen your favourite music or watch your favourite show while the doctor operates on you.
</li>
<li>Lounge for a while in our recliners till you feel better.</li>
        </ul>
          </div>
          </div>
      </div>
      <div className="dental-bar-menu" style={{ margin: " 0 0px",backgroundColor:"white" }}>
      <h2 className="menu-title" style={{ textAlign: "center",  color: " black" }}>
        Bombay Dental Company Menu
      </h2>
      <Slider {...sliderSettings}>
        {barItems.map((item, index) => (
          <div key={index} className="menu-item" style={{ textAlign: "center", height:"100%"}}>
            <div className="icon" style={{ marginBottom: "10px" ,color: " #0047AB"}}>
              {item.icon}
            </div>
            <p className="label" style={{ color: " #0047AB" }}>
              {item.label}
            </p>
          </div>
        ))}
      </Slider>
    </div>

    <div className="visit-us-container">
  <div className="images-container">
    <img src={dental1} alt="Waiting Area" className="image-item" />
    <img src={dental2} alt="Exam Room" className="image-item" />
    <img src={dental3} alt="Sign" className="image-item" />
    <img src={dental4} alt="Lounge" className="image-item" />
  </div>
  <div className="info-container">
    <h1 className='visit'>Visit Us</h1>
    <p className='weare'>
      We are conveniently located right on the Worli Naka, on the first floor of Atur House, opposite the Bharat Petroleum Pump. Our guards are very helpful, and free parking is provided easily upon asking.
    </p>
    <div className="lhflex">

    <div className="location">
      <h1 className='tp'><IoLocationOutline /></h1>
      <p> Bombay Dental Company<br />
        Atur House<br />
        First Floor, Flat no 2<br />
        Worli Naka, Worli<br />
        Mumbai 400018
      </p>
      <a href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018" className="directions-link" target="_blank" rel="noopener noreferrer">Get Directions</a>
    </div>
    <div className="hours">
      <h1 className='tp'><IoTimeOutline /></h1>
      <p> Mon-Sat 9 am – 7 pm<br />
        Sun 10 am – 2 pm<br />
        Thursday off
      </p>
    </div>
    </div>
  </div>
  <div className="map-container">
  <iframe
  src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
  width="100%"
  height="450"
  style={{ border: "8px",borderRadius:"18px "}}
  allowFullScreen
  loading="lazy"
  title="Google Maps Location of Bombay Dental Company"/>
  </div>
</div>
    <div className="home-sec8">
    <div className="book-visit-container">
      <div className="online">
        <h1 className='book'>Book your visit online</h1>
        <p className='view'>Book your visit online and enjoy our unique No-wait policy, so that you have time for what you enjoy, and not spend your precious time in the doctor’s waiting area.
         A few lucky callers every month will be randomly shortlisted for a free scaling and polishing session.</p>
         <a href="/booknow" > <button className="book-button1">BOOK ONLINE</button></a>
      </div>
    </div>
    </div>
    </div>
  );
}

export default PatientComfort;
